export default {
  issuerAgreementList: [],
  activeIssuerAgreement: {},
};
